module.exports = "<div class=\"container\">\n  <h1>Flash-U Layouteditor</h1>\n\n  <p>\n    <a href=\"/superadmin\">Flash-U Login</a>\n  </p>\n\n\n</div>"